module.exports = __webpack_public_path__ + "media/images/country_flags/ck-4ee0fe55a27a021847beb928172d22da.png";